export const services = [
  {
    id: 1,
    icon: "ri-temp-cold-line",
    title: "AC Repair",
    description:
      "Fast, accurate diagnostics and repairs to restore your cooling system to peak performance. We handle all makes and models.",
    href: "/services",
    featured: true,
  },
  {
    id: 2,
    icon: "ri-tools-line",
    title: "AC Installation & Replacement",
    description:
      "Expert installation of high-efficiency systems sized correctly for your space, with minimal disruption.",
    href: "/services",
    featured: false,
  },
  {
    id: 3,
    icon: "ri-shield-check-line",
    title: "Preventative Maintenance",
    description:
      "Scheduled tune-ups that extend system lifespan, improve efficiency, and prevent costly breakdowns.",
    href: "/services",
    featured: false,
  },
  {
    id: 4,
    icon: "ri-alarm-warning-line",
    title: "Emergency HVAC Service",
    description:
      "Same-day emergency response when your system fails. We prioritize your comfort and safety.",
    href: "/services",
    featured: false,
  },
  {
    id: 5,
    icon: "ri-cloud-windy-line",
    title: "Air Duct Cleaning",
    description:
      "Professional air duct cleaning to improve indoor air quality, system efficiency, and airflow throughout your property.",
    href: "/services",
    featured: false,
  },
  {
    id: 6,
    icon: "ri-fire-line",
    title: "Furnace Repair & Heating",
    description:
      "Full furnace and heater repair and replacement services to keep you comfortable during cooler months.",
    href: "/services",
    featured: false,
  },
];

export const processSteps = [
  {
    id: 1,
    number: "01",
    title: "System Evaluation",
    description: "Thorough inspection of your existing system to identify issues and assess overall condition.",
  },
  {
    id: 2,
    number: "02",
    title: "Clear Recommendations",
    description: "Transparent, jargon-free explanation of findings and options — no pressure, no surprises.",
  },
  {
    id: 3,
    number: "03",
    title: "Precision Service",
    description: "Expert repair or installation carried out by certified technicians using quality components.",
  },
  {
    id: 4,
    number: "04",
    title: "Performance Testing",
    description: "Full system testing to confirm everything operates at peak efficiency before we leave.",
  },
  {
    id: 5,
    number: "05",
    title: "Ongoing Support",
    description: "Post-service follow-up and maintenance plans to keep your system running long-term.",
  },
];

export const whyChooseUs = [
  {
    id: 1,
    icon: "ri-time-line",
    title: "Fast Response Times",
    description: "Same-day service for most calls. Emergency availability when you need it most.",
  },
  {
    id: 2,
    icon: "ri-user-star-line",
    title: "Experienced Technicians",
    description: "Certified HVAC professionals with years of hands-on experience across all system types.",
  },
  {
    id: 3,
    icon: "ri-leaf-line",
    title: "High-Efficiency Focus",
    description: "We recommend and install systems engineered to reduce energy costs while maximizing comfort.",
  },
  {
    id: 4,
    icon: "ri-eye-line",
    title: "Transparent Recommendations",
    description: "Honest assessments with no upselling. We tell you what you actually need.",
  },
  {
    id: 5,
    icon: "ri-medal-line",
    title: "Licensed & Insured",
    description: "Fully licensed HVAC contractors carrying complete liability coverage for your protection.",
  },
  {
    id: 6,
    icon: "ri-line-chart-line",
    title: "Long-Term Performance",
    description: "Our approach extends system lifespan and maintains peak performance year after year.",
  },
];

export const serviceAreas = [
  { id: 1, name: "Dallas", href: "/location-dallas" },
  { id: 2, name: "Plano", href: "/location-dallas" },
  { id: 3, name: "Irving", href: "/location-dallas" },
  { id: 4, name: "Garland", href: "/location-dallas" },
  { id: 5, name: "Richardson", href: "/location-dallas" },
  { id: 6, name: "Mesquite", href: "/location-dallas" },
  { id: 7, name: "McKinney", href: "/location-dallas" },
  { id: 8, name: "Frisco", href: "/location-dallas" },
];